import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=4cd8621c&scoped=true&"
import script from "./HotGoods.vue?vue&type=script&lang=js&"
export * from "./HotGoods.vue?vue&type=script&lang=js&"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=4cd8621c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd8621c",
  null
  
)

export default component.exports